import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-form-submit-button"
export default class extends Controller {
  static targets = [ "checkDate" ]

  connect() {
  }

  removeCheckDate() {
    this.checkDateTarget.value = ''
  }
}
